export default __webpack_public_path__ + "static/media/i234hk.b1dd93ec.webp";